import { useEffect } from 'react';

const BASE_TITLE = 'AlphaMoeMoe';
const DEFAULT_TITLE = 'AlphaMoeMoe: Youtube 美股博主观点回顾';

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : DEFAULT_TITLE;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
